<template>
    <div id="trs-login">
        <div class="container">
            <div class="row">
                <div class="col-md-4 offset-md-4">
                    <div class="box" style="padding: 25px">
                        <div class="box-ct">
                            <div class="text-center">
                                <a href="#">
                                    <img src="@/assets/img/logo-login.png"/>
                                </a>
                                <h4 class="text-center">
                                    {{$t('login.label.header')}}
                                </h4>
                            </div>
                            <hr class="border-light">
                            <form id="formSignIn">
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <button class="btn btn-border">
                                                <i class="fa fa-user"></i>
                                            </button>
                                        </div>
                                        <input type="text"
                                               class="form-control"
                                               v-model="username"
                                               :placeholder="$t('login.label.username')"
                                               id="fLogin_username" value=""
                                               v-remove-fullwidth-character
                                               v-keep-only-character>
                                    </div>

                                </div>
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <button class="btn btn-border">
                                                <i class="fa fa-lock"></i>
                                            </button>
                                        </div>
                                        <input type="password"
                                               class="form-control"
                                               v-model="password"
                                               :placeholder="$t('login.label.password')"
                                               id="fLogin_password" value=""
                                               v-remove-fullwidth-character
                                               v-keep-only-character-pwd>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button class="btn btn-warning btn-block btn-lg" @click.prevent="submitForm">
                                        {{$t('btn.login')}}
                                    </button>
                                </div>
                                <p class="text-center">
                                    <a href="">
                                        {{$t("login.label.forgot_pass")}}
                                    </a></p>
                            </form>
                            <template v-if="errorMessage">
                                <div class="alert alert-danger" id="errorMess" style="text-align: center">
                                    {{errorMessage}}
                                </div>
                            </template>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: "Login",
  data() {
    return {
      errorMessage: "",
        username: "",
        password: ""
    }
  },
  methods: {
    submitForm() {
      const {username, password} = this;
      if (username == null || username.trim() === "") {
        this.errorMessage = this.$t('MSG_NAB115');
        return;
      }
      if (password == null || password.trim() === "") {
        this.errorMessage = this.$t('MSG_NAB116');
        return;
      }
      this.$service
          .getService("auth")
          .signIn(null, {params: {username, password}})
          .then(async ({status}) => {
            if (status === 200) {
              await this.$router.push('/index');
            } else {
              this.errorMessage = "ID or Password not match";
            }
          });
    },
  }
}
</script>

<style scoped>

</style>
